<template>
  <v-container fluid class="gl-ledger-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex flex-start justify-md-start">
              <v-btn to="/gl-ledger/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="gl-ledgers-table"
              show-select
              single-select
              item-key="_id"
              sort-by="ledger"
              :footer-props="footer"
              :headers="header_ledgers"
              :items="glledgers"

              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="isDelete"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Sales Channel?
                    </v-card-title>

                    <v-card-text>
                      {{ delete_ledger.ledgername }}
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="isDelete = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(delete_ledger)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.image="{ item }">
                <v-avatar v-if="item.ledgerimage" size="35">
                  <img v-bind:src="item.ledgerimage" alt="">
                </v-avatar>
                <v-avatar
                  v-else
                  color="warning"
                  size="35">
                  <span class="white--text headline">{{ item.ledgername[0].toUpperCase() }}</span>
                </v-avatar>
              </template>
              <template v-slot:item.ledgername="{ item }">
                <p class="two-line"><a class="primaryConst--text">{{ item.ledgername }}</a></p>
                <p class="two-line">{{ item.ledgerinfo }}</p>
              </template>
              <template v-slot:item.ledgerstatus="{ item }">
                <v-chip
                  :color="getStatusColor(item.ledgerstatus)"
                  small>
                  {{ item.ledgerstatus }}
                </v-chip>
              </template>
              <template v-slot:item.isTaxable="{ item }">
                <v-icon v-if="item.isTaxable==true" size="18" color="blue">mdi-check</v-icon>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-US", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import config from "../../../config"
import { mapState, mapActions } from 'vuex'
import { getStatusColor } from '@/util/tools';

export default {
  name: 'GLLedgerList',
  data() {
    return {
      config,
      snackbar: null,
      isDelete: false,
      delete_ledger: {},
      header_ledgers: [
        { text: 'Type', value: 'ledgertype', width: "10%"  },
        { text: 'Code', value: 'ledgercode' },
        { text: 'Name', value: 'ledgername' },
        { text: 'Status', value: 'ledgerstatus', width: "10%"  },
        { text: 'Create', value: 'createdAt', width: "10%"  },
        { text: 'Tax', value: 'isTaxable', width: "2%" },
        { text: 'Actions', value: 'actions', sortable: false, width: "10%" },
      ],
      footer: {'items-per-page-options': [100, 500, 1000, 5000]},
      itemPerPage: 500,
      selected: [],
      getStatusColor: getStatusColor,
    }
  },
  computed: {
    ...mapState('GLLedger', ['glledgers', 'isReceiving', 'isDeleting', 'idToDelete', 'glledgersMessage', 'isUpdating']),
  },
  methods: {
    ...mapActions('GLLedger', ["getGLLedgersRequest","deleteGLLedgerRequest","updateGLLedgerRequest","insertGLLedgerRequest"]),
    editItem(item) {
      this.$router.push({ name: 'GLLedgerEdit', params: item })
    },
    deleteItem(item) {
      this.deleteGLLedgerRequest(item);
      this.isDelete = false;
    },
    deleteDialog(item) {
      this.isDelete = true;
      this.delete_ledger = {
        _id: item._id,
        ledgername: item.ledgername,
      }
    },
  },
  async created () {
    await this.getGLLedgersRequest()
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
